import styled from "styled-components/macro";
import { Paper } from "@mui/material";
/* istanbul ignore next */
export const Dropdown = styled(Paper)`
  box-shadow: ${(props) => props.theme.popover.boxShadow};
`;
